import { ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import throttle from 'lodash/throttle';

export const useScrollPosition = function(id) {
  let scrollPosition = ref(0);
  let scrollableElement = null;

  let onResize = function() {
    scrollPosition.value = scrollableElement.scrollTop;
  };
  let onResizeDebounced = throttle(onResize, 500);

  onMounted(() => {
    scrollableElement = document.getElementById(id);
    scrollableElement.addEventListener('scroll', onResizeDebounced);
  });
  onBeforeUnmount(() => {
    scrollableElement.removeEventListener('scroll', onResizeDebounced);
  });

  return { scrollPosition };
};
